import { render, staticRenderFns } from "./ModalSetPendency.vue?vue&type=template&id=3a178124&scoped=true&"
import script from "./ModalSetPendency.vue?vue&type=script&lang=ts&"
export * from "./ModalSetPendency.vue?vue&type=script&lang=ts&"
import style0 from "./ModalSetPendency.vue?vue&type=style&index=0&id=3a178124&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a178124",
  null
  
)

export default component.exports